import { getIcon } from '../../icons/utils'
import styles from './AddEntityFieldButton.module.css'
import { PropsWithChildren } from 'react'

type AddEntityFieldButtonProps = {
  onClick: () => void
  disabled?: boolean
}

export const AddEntityFieldButton: React.FC<PropsWithChildren<AddEntityFieldButtonProps>> = ({
  onClick,
  disabled,
  children,
}) => {
  return (
    <button type='button' onClick={onClick} className={styles.button} disabled={disabled}>
      <span className={styles.iconContainer}>{getIcon('plus')}</span>
      <span className='medium'>{children}</span>
    </button>
  )
}
